import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckInKioskUiModule } from '@frontend/check-in-kiosk/ui/src';
import { CheckOutRoutedComponent } from './check-in-kiosk-feature-check-out-routed.component';

@NgModule({
  imports: [CommonModule, CheckInKioskUiModule],
  declarations: [CheckOutRoutedComponent],
  exports: [CheckOutRoutedComponent],
})
export class CheckInKioskFeatureCheckOutModule {}
